
import React from 'react'
import { app, api, use } from 'xadmin'
import _ from 'lodash'
import { Icon } from 'xadmin-ui'
import { Button, Tooltip, message } from 'antd'

const Component = ({ nodes }) => {
  const [loading, setLoading] = React.useState(false)
  const { dashboard: { data } } = use('dashboard')
  const node = data?.node || {}
  let model = node.model

  const nav = d => {
    if (!node.department || node.department.length == 0) {
      return message.warning('资产没有选择部门')
    }
    const department = node.department[0]
    setLoading(true)
    api('Node')
      .query(
        { order: { uid: 'ASC' }, fields: ['uid'] },
        { where: { model, department } })
      .then(({ items }) => {
        setLoading(false)
        if (items && items.length > 0) {

          if (items.length == 1) {
            return message.warning('部门' + items[0].department[0]?.name + '没有其他' + items[0].model?.name)
          }

          const es = _.sortBy(items, e => e.uid)
          const index = _.findIndex(es, e => e.id == node.id)

          const next = d == 1 ?
            ((index >= 0 && index + 1 < es.length) ? es[index + 1] : es[0]) :
            (index > 0 ? es[index - 1] : es[es.length - 1])
          app.go(`/app/model/node/${next.id}/view`)
        }
      })
  }

  return (
    <Button.Group loading={loading}>
      <Tooltip placement="top" title={'查看上一个'}>
        <Button icon={<Icon type="caret-left" />} onClick={() => nav(-1)} disabled={!node.department || node.department.length == 0} />
      </Tooltip>
      <Tooltip placement="top" title={'查看下一个'}>
        <Button icon={<Icon type="caret-right" />} onClick={() => nav(1)} disabled={!node.department || node.department.length == 0} />
      </Tooltip>
    </Button.Group>
  );
}

const NodeNavButton = {
  title: '资产切换按钮',
  category: '业务选择器',
  icon: require('./../icon/资产切换按钮.svg'),
  component: Component,
  paramSchema: {},
  initLayout: { width: 80, height: 34 }
}

export default NodeNavButton